import { Modal, Table } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import { ModalProps } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getAggregationModalDetail } from "Services/Financial";
import { toPersianNum } from "utils/helpers";
import { ResponseHandler } from "components";
import "./aggregationModal.scss";

interface AggregationModalProps extends ModalProps {
    vendorID: string;
}

const AggregationModal: React.FC<AggregationModalProps> = ({ ...props }) => {
    const { id } = useParams<{ id: string }>();
    const {
        data: detail,
        isLoading,
        isError,
    } = useQuery(
        ["vendorAggregation", props.vendorID],
        () => getAggregationModalDetail({ id, vendorId: props.vendorID }),
        {
            enabled: !!props.vendorID,
        }
    );

    let allPay = 0;
    //@ts-ignore
    if (detail?.data) {
        detail?.data.payments.forEach((element: any) => {
            allPay += element.amount;
        });
    }

    const RawPayment =
        allPay +
        detail?.data.kitchen_final_share -
        detail?.data.total_drink_share -
        detail?.data.prev_dept;

    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="rtl w-100 aggregation-modal"
            {...props}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    جدول تجمیع دوره های مالی
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ResponseHandler
                    loading={isLoading}
                    error={isError}
                    response={detail?.data}
                    noDataText="اطلاعاتی موجود نیست."
                >
                    <Table
                        size="sm"
                        bordered
                        responsive="lg"
                        className="border-top border-left border-right bg-light"
                    >
                        <thead>
                            <tr>
                                <th>مجموع پرداختی‌ها(ریال)</th>
                                <th>مبلغ نوشیدنی(ریال)</th>
                                <th>سهم نهایی کیچن(ریال)</th>
                                <th>برداشت کیچن از کیف پول(ریال)</th>
                                <th>پراخت خالص(ریال)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">
                                    {toPersianNum(allPay)}
                                </td>
                                <td>
                                    {toPersianNum(
                                        detail?.data.total_drink_share
                                    )}
                                </td>
                                <td>
                                    {toPersianNum(
                                        detail?.data.kitchen_final_share
                                    )}
                                </td>
                                <td>{toPersianNum(detail?.data.prev_dept)}</td>
                                <td>{toPersianNum(RawPayment)}</td>
                            </tr>
                        </tbody>
                    </Table>
                </ResponseHandler>
            </Modal.Body>
        </Modal>
    );
};

export default AggregationModal;
